<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box" style="background-color: white;" >
        <a  class="logo logo-light">
          <div style="position:relative; width:100%; height:70px; min-height:50px; display:flex; align-items:center; justify-content:center;">
            <img #logoImg
                 [src]="'data:image/png;base64,' + logo"
                 alt="Logo"
                 (load)="logoImg.style.opacity='1';"
                 style="width:100%; max-height:70px; min-height:50px; opacity:0; transition:opacity .25s ease-in-out; display:block;" />
          </div>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar()">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <div class="topnav">
        <div class="container-fluid">
          <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
            <div class="collapse navbar-collapse active" [ngClass]="{'show': ocultarMenu}" id="topnav-menu-content">
              <ul class="navbar-nav">
                <ng-container *ngFor="let item of menuItems">
                  <li class="nav-item">
                    <a class="nav-link"
                      style="color: white;border-right: 1px solid #666574;" href="javascript: void(0);" role="button">
                      <label for="arrow-down" style="white-space: nowrap;"> {{item.S02DES}} ></label>
                    </a>
                  </li>

                  <li class="nav-item dropend" *ngFor="let subitem of item.OPCIONES">
                    <a class="nav-link dropdown-toggle"
                      style="color: white;border-right: 1px solid #666574;" href="javascript: void(0);" role="button" *ngIf="hasItems(subitem)">
                      <label for="" > {{subitem.S13DES}}</label>
                    </a>
                    <div class="dropdown-menu" *ngIf="hasItems(subitem)">
                      <ng-template ngFor let-i="index" let-subSubitem [ngForOf]="subitem.OPCIONES">

                        <a class="dropdown-item side-nav-link-ref " style="width: auto;"
                          (click)="AbrirMenu(subSubitem.SYS02CON, subSubitem.S14DES, subSubitem.SYS02TIP )" routerLinkActive="active">
                          {{ subSubitem.S14DES}}</a>
                      </ng-template>
                    </div>

                  </li>
                </ng-container>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-lg-inline-block" ngbDropdown>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Buscar ...">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="fa fa-magnifying-glass"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div *ngIf="analitica" class="d-none d-lg-inline-block">
        <button type="button" class="btn header-item noti-icon" (click)="abrirFlexmonster()" title="Analítica" >
            <i class="fa fa-chart-column"></i>
        </button>
      </div>

      <div class="d-none d-lg-inline-block">
        <button type="button" class="btn header-item noti-icon " (click)="abrirModal($event)" title="Configuración" >
            <i class="mdi mdi-account-settings"></i>
        </button>
      </div>


      <div class="d-none d-lg-inline-block">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="fa fa-expand"></i>
        </button>
      </div>

      <div class="d-inline-block">
        <button type="button" class="btn header-item noti-icon" (click)="AbrirArchivos()" title="Archivos">
          <i class="fa fa-folder text-warning"></i>
        </button>
      </div>


      <div class="dropdown d-none d-lg-inline-block" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" ngbDropdownToggle>
          <i class="bx bx-customize"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" ngbDropdownMenu>
          <div class="px-lg-2">
            <div class="row no-gutters">

              <div class="col" *ngFor="let accion of acciones">
                <a class="dropdown-icon-item" href="{{accion.PAD34URL}}" target="blank" (click)="clickAccion($event, accion)">
                  <img src="data:image/png;base64, {{accion.PAD34ICO}}" alt="{{accion.PAD34TIT}}" class="tamano" width="64px" height="64px">
                  <span>{{accion.PAD34TIT}}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- INICIO MODAL -->

      <ng-template #contenido let-modal>
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button type="button" style="margin-left: 10px" (click)="modal.dismiss()"
            class="btn btn-info btn-label waves-light"><i
              class="fas fa-sign-out-alt label-icon"></i> Salir</button>
        </div>
        <div class="modal-body">

          <app-email-details [WsLlaves]=WsLlaves>
          </app-email-details>
        </div>
        <div class="modal-footer">
          <button type="button" style="margin-left: 10px" (click)="modal.dismiss()"
            class="btn btn-info btn-label waves-light"><i
              class="fas fa-sign-out-alt label-icon"></i> Salir</button>
        </div>
      </ng-template>


      <!-- END MODAL -->


      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="onSettingsButtonClicked()" title="Buscador">
          <i class="mdi mdi-text-search"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block fav-dropdown" ngbDropdown #favDrop="ngbDropdown" display="static" [autoClose]="'outside'"
        (openChange)="$event && enfocarBuscadorFavoritos(favBuscar)">
        <button type="button" class="btn header-item noti-icon" ngbDropdownToggle aria-haspopup="true"
          (click)="cargarToolbar()" title="Menú Favoritos">
          <i class="fa fa-star text-warning"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end fav-panel" ngbDropdownMenu>
          <div class="fav-head">
            <div class="fav-head__title">
              <span class="fav-head__icon"><i class="fa fa-star"></i></span>
              <div>
                <h6 class="fav-head__name">Favoritos</h6>
                <span class="fav-head__count">
                  <ng-container *ngIf="cargandoFavoritos && favoritos.length === 0; else totalFavoritos">Cargando…</ng-container>
                  <ng-template #totalFavoritos>{{ favoritos.length }} {{ favoritos.length === 1 ? 'opción' : 'opciones' }}</ng-template>
                </span>
              </div>
            </div>
          </div>

          <div class="fav-search" [hidden]="favoritos.length <= 5 && !filtroFavoritos">
            <i class="bx bx-search"></i>
            <input #favBuscar type="text" class="fav-search__input" placeholder="Buscar en favoritos…"
              [(ngModel)]="filtroFavoritos" (keydown.enter)="abrirPrimerFavorito(favDrop)" autocomplete="off" />
            <button *ngIf="filtroFavoritos" type="button" class="fav-search__clear" (click)="filtroFavoritos = ''" title="Limpiar">
              <i class="bx bx-x"></i>
            </button>
          </div>

          <div class="fav-body">
            <div class="fav-grid" *ngIf="cargandoFavoritos && favoritos.length === 0">
              <div class="fav-item fav-item--skeleton" *ngFor="let s of [1,2,3,4]">
                <span class="fav-item__badge"></span>
                <span class="fav-item__line"></span>
              </div>
            </div>

            <div class="fav-grid" *ngIf="favoritosFiltrados.length > 0">
              <button type="button" class="fav-item" *ngFor="let fav of favoritosFiltrados"
                (click)="abrirFavorito(fav, favDrop)" [title]="fav.SYS02DES">
                <span class="fav-item__badge">{{ inicialFavorito(fav.SYS02DES) }}</span>
                <span class="fav-item__name">{{ fav.SYS02DES }}</span>
                <i class="bx bx-chevron-right fav-item__go"></i>
              </button>
            </div>

            <div class="fav-empty" *ngIf="!cargandoFavoritos && favoritos.length === 0">
              <span class="fav-empty__icon"><i class="fa fa-star"></i></span>
              <p class="fav-empty__title">Aún no tienes favoritos</p>
              <p class="fav-empty__text">Las opciones que agregues a favoritos aparecerán aquí para abrirlas con un clic.</p>
            </div>

            <div class="fav-empty" *ngIf="favoritos.length > 0 && favoritosFiltrados.length === 0">
              <span class="fav-empty__icon fav-empty__icon--muted"><i class="bx bx-search"></i></span>
              <p class="fav-empty__title">Sin resultados</p>
              <p class="fav-empty__text">Ningún favorito coincide con "{{ filtroFavoritos }}".</p>
            </div>
          </div>
        </div>
      </div>

      <div class="dropdown" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
          title="Notificaciones" ngbDropdownToggle>
          <i class="fa fa-bell"></i>
          <span class="badge bg-danger rounded-pill">{{this.cantidad}}</span>
        </button>
      
        <div class="dropdown-menu dropdown-menu-v2-notif" ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">
          
          <div class="notif-header-v2">
            <div class="row align-items-center">
              <div class="col">
                <h6>{{ 'HEADER.NOTIFICATIONS.TITLE' | translate}}</h6>
              </div>
              <div class="col-auto">
                <a href="javascript: void(0);" (click)="AbrirNotificacion()">
                  {{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate}}
                </a>
              </div>
            </div>
          </div>
      
          <ngx-simplebar style="position: relative; max-height: 530px;">
            <a href="javascript: void(0);" class="notification-item-v2"
              *ngFor="let notificaciones of notificaciones;">
              <div class="media">
                <div class="avatar-v2-notif">
                  <i class="fa fa-mail-bulk"></i>
                </div>
                <div class="media-body-v2" (click)="EventoClickLista(notificaciones.PAD14CON)">
                  <h6>{{notificaciones.PAD14ASU}}</h6>
                  <div class="text-muted-v2">
                    <i class="fa fa-clock"></i>
                    {{notificaciones.PAD14FEV}}
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>
      
          <div class="notif-footer-v2">
            <a class="btn-v2-link" href="javascript:void(0)" (click)="AbrirNotificacion()">
              <i class="fa fa-circle-right"></i> 
              {{ 'HEADER.NOTIFICATIONS.LOAD_MORE' | translate}}
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>

          <i class="fa-solid fa-right-from-bracket fa-2xl"></i>
          <!-- <img class="rounded-circle header-profile-user" src="assets/images/avatarsys2024.png" alt="Header Avatar">
          <span class="d-none d-xl-inline-block me-1">{{this.dataestudiante}} </span>
          <i class="fa-solid fa-chevron-down d-none d-xl-inline-block"></i>-->
        </button>
        <div class="dropdown-menu dropdown-menu-end usr-panel" ngbDropdownMenu>
          <div class="usr-head">
            <span class="usr-head__avatar">{{ iniciales }}</span>
            <div class="usr-head__datos">
              <strong>{{ dataestudiante || 'Mi cuenta' }}</strong>
              <span *ngIf="usuarioSesion">{{ usuarioSesion }}</span>
            </div>
          </div>

          <div class="usr-lista">
            <button type="button" class="usr-item" (click)="abrirModal($event)">
              <span class="usr-item__icono"><i class="fa-solid fa-sliders"></i></span>
              <span class="usr-item__texto">
                <strong>{{'HEADER.LOGIN.SETTINGS' | translate}}</strong>
                <small>Compañía, sede y preferencias</small>
              </span>
              <i class="fa-solid fa-chevron-right usr-item__flecha"></i>
            </button>

            <button type="button" class="usr-item" (click)="abrirCambioContrasena()">
              <span class="usr-item__icono"><i class="fa-solid fa-key"></i></span>
              <span class="usr-item__texto">
                <strong>Cambiar contraseña</strong>
                <small>Actualiza tu clave de acceso</small>
              </span>
              <i class="fa-solid fa-chevron-right usr-item__flecha"></i>
            </button>
          </div>

          <div class="usr-pie">
            <button type="button" class="usr-salir" (click)="logout()">
              <i class="fa-solid fa-power-off"></i>
              {{ 'HEADER.LOGIN.LOGOUT' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Drawer -->
  <div class="mm-backdrop" [class.mm-show]="ocultarMenu" (click)="toggleMenubar()"></div>

  <aside class="mm-drawer" [class.mm-open]="ocultarMenu" aria-label="Menú principal">

    <!-- Encabezado -->
    <div class="mm-head">
      <img class="mm-logo" [src]="'data:image/png;base64,' + logo" alt="Logo">
      <button type="button" class="mm-close" (click)="toggleMenubar()" aria-label="Cerrar menú">
        <i class="fa fa-xmark"></i>
      </button>
    </div>

    <!-- Buscador de opciones -->
    <div class="mm-search">
      <i class="fa fa-magnifying-glass"></i>
      <input #mmFiltro type="text" placeholder="Buscar opción..." (input)="0">
      <button *ngIf="mmFiltro.value" type="button" class="mm-search-clear"
              (click)="mmFiltro.value = ''" aria-label="Limpiar búsqueda">
        <i class="fa fa-xmark"></i>
      </button>
    </div>

    <!-- Módulos -->
    <nav class="mm-body">
      <ng-container *ngFor="let item of menuItems">
        <details class="mm-module" [open]="!!mmFiltro.value">
          <summary class="mm-module-head">
            <span class="mm-module-icon"><i class="fa fa-layer-group"></i></span>
            <span class="mm-module-title">{{ item.S02DES }}</span>
            <i class="fa fa-chevron-down mm-chevron"></i>
          </summary>

          <div class="mm-module-body">
            <ng-container *ngFor="let subitem of item.OPCIONES">
              <details class="mm-group" *ngIf="hasItems(subitem)" [open]="!!mmFiltro.value">
                <summary class="mm-group-head">
                  <span>{{ subitem.S13DES }}</span>
                  <i class="fa fa-chevron-down mm-chevron"></i>
                </summary>

                <div class="mm-links">
                  <ng-container *ngFor="let subSubitem of subitem.OPCIONES">
                    <a href="javascript:void(0);" class="mm-link"
                      *ngIf="!mmFiltro.value || (subSubitem.S14DES || '').toLowerCase().includes(mmFiltro.value.toLowerCase())"
                      (click)="AbrirMenu(subSubitem.SYS02CON, subSubitem.S14DES, subSubitem.SYS02TIP); toggleMenubar()">
                      <i class="fa fa-angle-right"></i>
                      <span>{{ subSubitem.S14DES }}</span>
                    </a>
                  </ng-container>
                </div>
              </details>
            </ng-container>
          </div>
        </details>
      </ng-container>
    </nav>

    <!-- Acciones rápidas -->
    <div class="mm-foot">
      <button type="button" class="mm-action" (click)="abrirModal($event); toggleMenubar()">
        <i class="mdi mdi-account-settings"></i>
        <span>Configuración</span>
      </button>
      <button *ngIf="analitica" type="button" class="mm-action" (click)="abrirFlexmonster(); toggleMenubar()">
        <i class="fa fa-chart-column"></i>
        <span>Analítica</span>
      </button>
      <button type="button" class="mm-action" (click)="AbrirArchivos(); toggleMenubar()">
        <i class="fa fa-folder"></i>
        <span>Archivos</span>
      </button>
      <button type="button" class="mm-action" (click)="abrirCambioContrasena(); toggleMenubar()">
        <i class="fa-solid fa-key"></i>
        <span>Cambiar contraseña</span>
      </button>
      <button type="button" class="mm-action mm-action--danger" (click)="logout()">
        <i class="fa-solid fa-power-off"></i>
        <span>Salir</span>
      </button>
    </div>
  </aside>
</header>
